@if (substatusDate && !editMode) {
  <span class="wrapper">
    {{ substatusDate.date | date: "MM/dd/yyyy" }}
    <date-target-indicator
      [target]="substatusDate.target"
    ></date-target-indicator>
  </span>
}
@if (editMode) {
  <sub-status-datepicker
    [substatus]="substatus"
    [subsequence]="subsequence"
    [project_status_id]="project_status_id"
    [substatusDate]="substatusDate"
  ></sub-status-datepicker>
}
